import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UpdatePharmacyProfile.css';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';

const UpdatePharmacyProfile = () => {
  const [formData, setFormData] = useState({
    pharmacy_address: '',
    city: '',
    state: '',
    country: '',
    latitude: '',
    longitude: '',
    logo: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const token = localStorage.getItem('access_token');
  const navigate = useNavigate();

  const GOOGLE_API_KEY = 'AIzaSyCeUwEIjvESLIv_658RhDLYfleCqmsdtNs'; // Use securely in production

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get('http://127.0.0.1:8000/users/users/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = res.data.profile;
        setFormData({
          pharmacy_address: data.pharmacy_address || '',
          city: data.city || '',
          state: data.state || '',
          country: 'Nigeria',
          latitude: data.latitude || '',
          longitude: data.longitude || '',
          logo: data.logo || '',
        });
      } catch (err) {
        setError('Failed to load profile.');
      }
    };

    fetchProfile();
  }, [token]);

  useEffect(() => {
    const timeout = setTimeout(async () => {
      const { pharmacy_address, city, state, country } = formData;
      if (pharmacy_address.trim() && city.trim() && state.trim() && country.trim()) {
        const fullAddress = `${pharmacy_address}, ${city}, ${state}, ${country}`;
        try {
          const geo = await axios.get(
            `https://maps.googleapis.com/maps/api/geocode/json`,
            {
              params: {
                address: fullAddress,
                key: GOOGLE_API_KEY,
              },
            }
          );

          const results = geo?.data?.results;
          if (results && results.length > 0) {
            const loc = results[0].geometry.location;
            setFormData((prev) => ({
              ...prev,
              latitude: loc.lat.toFixed(6),
              longitude: loc.lng.toFixed(6),
            }));
          }
        } catch (err) {
          console.error('Geocoding failed:', err);
        }
      }
    }, 800);

    return () => clearTimeout(timeout);
  }, [formData.pharmacy_address, formData.city, formData.state, formData.country]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const payload = {
        pharmacy_address: formData.pharmacy_address,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        latitude: parseFloat(formData.latitude) || 0,
        longitude: parseFloat(formData.longitude) || 0
      };

      await axios.put('http://127.0.0.1:8000/users/pharmacy/profile', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      setSuccess('Profile updated successfully!');
      setTimeout(() => navigate('/PharmacyProfile'), 2000);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Failed to update profile.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formDataUpload = new FormData();
    formDataUpload.append('logo', file);

    try {
      const res = await axios.put('http://127.0.0.1:8000/users/pharmacy/logo', formDataUpload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      setFormData((prev) => ({
        ...prev,
        logo: res?.data?.logo || prev.logo,
      }));
      setSuccess('Logo updated successfully!');
    } catch (err) {
      setError('Failed to upload profile image.');
    }
  };

  return (
    <div className="update-profile-layout">
      {/* Sidebar on the left */}
      <div className="sidebar-container">
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="update-profile-main">
        <div className="update-profile-container">
          <h2>Update Pharmacy Profile</h2>

          <div className="upload-image-section">
            <label htmlFor="profile-image-upload" className="image-upload-label">
              📷 Update Profile Image:
            </label>

            {formData.logo && (
              <img
                src={formData.logo}
                alt="Current Logo"
                style={{
                  width: '80px',
                  height: '80px',
                  objectFit: 'cover',
                  marginBottom: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                }}
              />
            )}

            <input
              type="file"
              id="profile-image-upload"
              accept="image/*"
              onChange={handleLogoUpload}
              className="image-upload-input"
            />
          </div>

          <form onSubmit={handleSubmit} className="update-profile-form">
            <label>Pharmacy Address:</label>
            <input
              type="text"
              name="pharmacy_address"
              value={formData.pharmacy_address}
              onChange={handleChange}
              required
            />

            <label>City:</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
            />

            <label>State:</label>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleChange}
              required
            />

            <label>Country:</label>
            <input
              type="text"
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
            />

            <label>Latitude:</label>
            <input
              type="number"
              name="latitude"
              value={formData.latitude}
              readOnly
            />

            <label>Longitude:</label>
            <input
              type="number"
              name="longitude"
              value={formData.longitude}
              readOnly
            />

            <button type="submit" disabled={loading}>
              {loading ? 'Updating...' : 'Update Profile'}
            </button>

            {error && <p className="error-text">{error}</p>}
            {success && <p className="success-text">{success}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdatePharmacyProfile;
